import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { SketchPicker, ColorResult } from "react-color";
import Button from "@material-ui/core/Button";
import NoFooterModal from "../NoFooterModal";
import { ModalBaseProps } from "../types";
import { ChoseButton, ColorPickerFooter, ColorPickerWrapper } from "./styles";

type ColorPickerModalProps = ModalBaseProps & {
  color: string;
  callbackFnc: (colorToSet: string) => void;
};

const ColorPickerModal = ({
  isOpen,
  toggleModal,
  callbackFnc,
  color,
}: ColorPickerModalProps) => {
  const { formatMessage } = useIntl();
  const [currentColor, setCurrentColor] = useState(color);

  const onColorChange = (newColor: ColorResult) => {
    setCurrentColor(newColor.hex);
  };

  return (
    <NoFooterModal
      title={formatMessage({
        id: "template_builder.set_color_appearance",
      })}
      isOpen={isOpen}
      toggle={toggleModal}
    >
      <ColorPickerWrapper>
        <SketchPicker color={currentColor} onChange={onColorChange} />
        <ColorPickerFooter>
          <ChoseButton
            selectColor={currentColor}
            variant="contained"
            onClick={() => callbackFnc(currentColor)}
            autoFocus
          >
            <FormattedMessage id="segments.module.colors.chose" />
          </ChoseButton>
          <Button variant="contained" onClick={() => callbackFnc("")}>
            <FormattedMessage id="segments.module.colors.decline" />
          </Button>
        </ColorPickerFooter>
      </ColorPickerWrapper>
    </NoFooterModal>
  );
};

export default ColorPickerModal;
